import {DateTime} from 'luxon';

export enum GiftCardStatus {
  pending = 'pending',
  active = 'active',
  expired = 'expired',
  depleted = 'depleted',
  disabled = 'disabled'
}

export interface GiftCardUsage {
  id: number;
  bookingId: number | null;
  stage: string;
  reservedAmount: number;
  appliedAmount: number;
  status: string;
  createdAt: DateTime | null;
  updatedAt: DateTime | null;
}

export interface GiftCard {
  id: number;
  code: string;
  status: GiftCardStatus | string;
  initialAmount: number;
  remainingAmount: number;
  recipientEmail: string;
  recipientFirstName: string | null;
  purchaserEmail: string | null;
  recipientUserEmail: string | null;
  deliveryDate: DateTime | null;
  expiresAt: DateTime | null;
  createdAt: DateTime | null;
  lastRedeemedAt: DateTime | null;
  usages: GiftCardUsage[];
}

const toDateTime = (value: string | null | undefined): DateTime | null => {
  return value ? DateTime.fromISO(value) : null;
};

export function mapGiftCardUsage(raw: any): GiftCardUsage {
  return {
    id: raw.id,
    bookingId: raw.bookingId ?? null,
    stage: raw.stage,
    reservedAmount: raw.reservedAmount,
    appliedAmount: raw.appliedAmount,
    status: raw.status,
    createdAt: toDateTime(raw.createdAt),
    updatedAt: toDateTime(raw.updatedAt),
  };
}

export function mapGiftCard(raw: any): GiftCard {
  return {
    id: raw.id,
    code: raw.code,
    status: raw.status,
    initialAmount: raw.initialAmount,
    remainingAmount: raw.remainingAmount,
    recipientEmail: raw.recipientEmail,
    recipientFirstName: raw.recipientFirstName ?? null,
    purchaserEmail: raw.purchaserEmail ?? null,
    recipientUserEmail: raw.recipientUserEmail ?? null,
    deliveryDate: toDateTime(raw.deliveryDate),
    expiresAt: toDateTime(raw.expiresAt),
    createdAt: toDateTime(raw.createdAt),
    lastRedeemedAt: toDateTime(raw.lastRedeemedAt),
    usages: Array.isArray(raw.usages) ? raw.usages.map(mapGiftCardUsage) : [],
  };
}

export function mapGiftCards(rawList: any[]): GiftCard[] {
  return rawList.map(mapGiftCard);
}
